import React from 'react';
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import { useQuery } from '@tanstack/react-query';
import { WorkshopAttendedGet } from '../../../Store/auth/register';
import Loading from '../../../Components/Loader/Loading';
const WorkshopAttended = () => {

    const gsnNoFromStorage = localStorage.getItem('gsn_no');

    const { isLoading: fieldLoading, data: questions } = useQuery({
        queryKey: 'WorkshopAttended',
        queryFn: () => WorkshopAttendedGet(gsnNoFromStorage ? gsnNoFromStorage : ''),
        cacheTime: 1000 * 60 * 5,
        staleTime: 0,
    });

    
    if (fieldLoading) return (<Loading />);

    const documentKeys = Object.keys(questions?.documents?.workshops_attended?.[0] || {});
    const workshopData = questions?.docs_answers?.workshops_attended || [];
  return (
    <>
        <div className='px-[10px] w-[100%] py-[17px]'>
            <ParagraphComp text='Workshop Attended' className='font-bold text-xl text-[#004878]' />
            <div className='overflow-y-auto max-h-[640px] relative'>
                <table className='w-[100%] mt-[15px]'>
                    <thead className='sticky top-0'>
                        <tr>
                            {documentKeys.map((key, index) => (
                                <th 
                                    key={index} 
                                    className={`${index === 0 ? 'rounded-tl-2xl' : documentKeys.length - 1 === index ? 'rounded-tr-2xl' : ''} bg-[#EDF2F6] text-md p-[16px]`}
                                    style={{ width: `${100 / documentKeys.length}%` }}
                                >
                                    {key}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {workshopData.map((ans, rowIndex) => (
                            <tr key={rowIndex}>
                                {documentKeys.map((key, index) => (
                                    <td 
                                        key={index} 
                                        className={`${index === 0 ? 'border-l-2' : documentKeys.length - 1 === index ? 'border-r-2' : ''} border-b-2 border-t-2 p-[15px] border-[#00487829]`}
                                    >
                                        {ans?.[key] !== null && ans?.[key] !== undefined ? ans[key] : 'N/A'}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    </>
  )
}

export default WorkshopAttended